import React from "react";
import Highlighter from "Components/common/Highlighter/Highlighter";
import { Icons } from "Assets/icons";
import { getData, postData, showToast } from "Source/globalFunction";
import { connect } from "react-redux";
import moment from "moment";
import { updateStatusComplete } from "@/src/reducers/tasks/tasks.service";
import Tooltip from "@/src/components/common/Elements/Tooltip/Tooltip";
import MaterialUITooltip from "@/src/components/common/Elements/Tooltip/MaterialUITooltip/MaterialUITooltip";

const style = {
    width: 450, 
    textAlign: "left",
    justifyContent: "flex-start"
}

const defaults = {
    holidays: [
        {date: null, name: null},
        {date: null, name: null},
        {date: null, name: null}
    ]
}

@connect(store => {
    return {
        tasks: store.processesTasks,
        loggedUser: store.loggedUser,
        taskObj: store.task
    };
})

class TaskName extends React.Component {
    shouldComponentUpdate(nextProps) {
        if(!_.isEqual(nextProps.taskObj, this.props.taskObj)) {
            if(!nextProps.taskObj.Selected.id ) {
                if((this.props.task.ref || {}).current && (this.props.task.otherRef || {}).current) {
                    this.props.task.ref.current.classList.remove("selected");
                    this.props.task.otherRef.current.classList.remove("selected");
                }
            }
        }

        if(!_.isEqual(nextProps.task, this.props.task) || !_.isEqual(nextProps.tasks.searchedQuery, this.props.tasks.searchedQuery)) {
            return true;
        }

        return false;
    }

    handleTaskCompletion = async () => {
        const { dispatch, task } = this.props;

        if (task.status === 'Completed') {
            return;
        }

        const response = await updateStatusComplete(task.id);

        if(response) {
            const responseData = response.data.data;

            if (responseData.error) {
                if (responseData.error === 'NOT_COMPLETED') {
                    showToast("error", responseData.errorDescription);
                } else {
                    showToast("error", `Task can’t be completed yet. Make sure it’s approved and all subtasks/dependencies are completed first.`);
                }
            }

            if (responseData.success) {
                dispatch({ type: "DELETE_TASKS_ITEM", id: task.id });
                dispatch({type: "UPDATE_PROCESSES_RATES_UPDATES"});
                
                showToast("success", `${task.task} has been <span class="completed">completed</span>`);
            }

            // TODO: Create task completed event for this
            dispatch({ type: "COMPLETE_TASK_SELECTED", taskId: task.id });
        }
    }

    openDetails = (e) => {
        const { dispatch, task, loggedUser } = this.props;

        e.preventDefault();

        if($('.taskListCategoryList .taskListRow').hasClass('selected')) {
            $('.taskListCategoryList .taskListRow').removeClass('selected');
        }

        if((task.ref || {}).current && (task.otherRef || {}).current) {
            task.ref.current.classList.add("selected");
            task.otherRef.current.classList.add("selected");
        }

        dispatch({ type: "SET_SCREEN_LOADER", Loading: true });

        // No need to call this if calendars are not used
        // getData(`/api/project/detail/${task.projectId}?info=${1}`, {}, c => {
        //     setTimeout(() => {
        //         if (c.status === 200 && c.data) {
        //             dispatch({ type: "SET_PROJECT_SELECTED", Selected: c.data });
        //             dispatch({ type: "UPDATE_SETTINGS_INIT", data: {
        //                 list: c.data.calendars_list,
        //                 calendars: {
        //                     default: c.data.project_calendar.default,
        //                     others: c.data.project_calendar.others.map(c => c.calendars)
        //                 }, 
        //                 workingDays: c.data.project_workdays,
        //                 holidays: [
        //                     ...c.data.project_holiday.filter(h => h.date && h.holiday).map(h => ({date: moment(h.date).format("MM/DD/YYYY"), holiday: h.holiday})),
        //                     ...c.data.project_holiday.filter(h => h.date && h.holiday).length < 3 ? defaults.holidays.filter((h, i) => i >= c.data.project_holiday.filter(h => h.date && h.holiday).length && i < 3) : []
        //                 ]
        //             }});
        //         } 
        //     }, 1000);
          
        // });

        getData(`/api/activityLog?taskId=${task.id}&page=1`, {}, c => {
            if (c.status === 200) {
                const { data } = c;
                dispatch({ type: "SET_ACTIVITYLOG_LIST", list: data.result, count: data.count });
            }
        });

        getData(`/api/conversation/getConversationList?page=1&linkType=task&linkId=${task.id}`, {}, c => {
            if (c.status === 200) {
                const { data } = c;
                dispatch({ type: "SET_COMMENT_LIST", list: data.result, count: data.count });
            }
        });

        getData(`/api/task/detail/${task.id}?starredUser=${loggedUser.data.id}`, {}, c => {
            if (c) {
                if (c.status === 200 && !c.data.error) {
                    dispatch({ type: "SET_TASK_SELECTED", Selected: c.data });
                    dispatch({ type: "SET_TASK_LOADING", Loading: "" });
                    dispatch({ type: "SET_SCREEN_LOADER", Loading: false });
                    $(`#task-details`).modal("show");
                } else {
                    showToast('error', c.data.message)
                }
            }
        });
        getData(`/api/timeLog/tasklog?taskId=${task.id}&page=1`, {}, c => {
            if (c.status === 200) {
                dispatch({ type: "SET_TASKTIMELOG_LIST", list: c.data.result, count: c.data.count });
                dispatch({ type: "SET_TOTAL_HOURS", total: c.data.total_hours });
            }
        });
    }

    render() {
        const { task, tasks } = this.props;
        
        return (
            <div class={`taskListRow searchable-row`} ref={task.ref} data-index={this.props.index} tabindex={this.props.index}>
                <div class="taskListRowCell" style={style}>
                    <div class="taskName">
                        <div class="taskNameActions">
                            <div class="taskIndicator milestoneIndicator">
                                <i class={`material-icons milestoneIcon ${task.isMilestone ? "active" : "" }`}>
                                    {task.isMilestone? "flag" : "outlined_flag" }
                                </i>
                            </div>
                            <div class="taskIndicator recurringIndicator">
                                {task.isRecurring ? Icons.RecurringIcon : Icons.RecurringIconDisabled }
                            </div>
                            <div class={`taskCompleteAction ${task.status && task.status.toLowerCase() === "completed" ? "completedTask" : ""}`}>
                                <span class="customCheckbox" onClick={this.handleTaskCompletion}>
                                    {task.status && task.status.toLowerCase() === "completed" ? (
                                        <i class="material-icons">check</i>
                                    ) : null}
                                </span>
                            </div>
                        </div>
                        <a href="#" onClick={this.openDetails}>
                            <div class="taskNameDetails">
                                <MaterialUITooltip placement="bottom" title={<span>{task.task}</span>} TransitionProps={{ timeout: 0 }}>
                                    <span class="taskNameText" data-tooltip-id={`${task.id}-taskName`}>
                                        <Highlighter 
                                            highlightClass="highlighted" 
                                            string={`${task.task.length >= 100 ? task.task.substr(0, 100) + "..." : task.task}`} 
                                            query={(tasks || {}).searchedQuery} 
                                        />
                                    </span>
                                </MaterialUITooltip>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        )
    }
}

export default TaskName;